import ClinicianInfoPopup from 'popups/ClinicianInfoPopup';

import { POPUP_VIEW } from './consts';

const routes = {
  [POPUP_VIEW.popup.clinicianInfoPopup]: ClinicianInfoPopup,
};

export default routes;
